/* Marinelie — Kit-Seite: Groessenwahl haelt alle Abschnitte im Gleichschritt. */
(function () {
  if (document.documentElement.dataset.mlkAktiv) return;
  document.documentElement.dataset.mlkAktiv = '1';

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-mlk-variante]');
    if (!knopf || knopf.disabled) return;

    var id = knopf.getAttribute('data-mlk-variante');
    var beschriftung = knopf.querySelector('span') ? knopf.querySelector('span').textContent : '';

    document.querySelectorAll('[data-mlk-id]').forEach(function (feld) { feld.value = id; });
    /* Der Preis stand frueher im Knopf und wurde hier nachgefuehrt. Er
       steht dort nicht mehr, und die Zeile war ohnehin gefaehrlich:
       data-mlk-preis tragen auch die Groessenknoepfe selbst, denen sie
       damit Titel und Preis aus dem Inneren geloescht hat. */
    document.querySelectorAll('[data-mlk-groesse]').forEach(function (g) { g.textContent = beschriftung; });
    document.querySelectorAll('[data-mlk-variante]').forEach(function (k) {
      var an = k.getAttribute('data-mlk-variante') === id;
      k.classList.toggle('is-aktiv', an);
      k.setAttribute('aria-checked', an ? 'true' : 'false');
    });

    var url = new URL(window.location);
    url.searchParams.set('variant', id);
    history.replaceState({}, '', url);
  });
})();
